var _excluded = ["children", "maxValue", "className", "size", "active", "withBorder", "data-qa"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
import PropTypes from "prop-types";
import { joinCn } from "@ati/uti";
var Counter = _ref => {
  var {
      children,
      maxValue,
      className,
      size = "medium",
      active,
      withBorder,
      "data-qa": dataQa = "counter"
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  var value = children;
  if (value > maxValue) {
    value = "".concat(maxValue, "+");
  }
  return /*#__PURE__*/React.createElement("span", _extends({}, props, {
    className: joinCn("glz-counter", active && "glz-is-active", withBorder && active && "glz-with-border", size !== "medium" && "glz-size-".concat(size), className),
    "data-qa": dataQa
  }), value);
};
Counter.propTypes = {
  /** Значение счетчика */
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** Если children больше значения этого пропа, то счетчик отобразится как `${maxCount}+` */
  maxValue: PropTypes.number,
  /** Внешние стили */
  className: PropTypes.string,
  /** Размер счетчика. Может быть medium и large */
  size: PropTypes.oneOf(["medium", "large"]),
  /** Окрашивает счетчик в красный цвет */
  active: PropTypes.bool,
  /** Добавляется белый border вокруг счетчика */
  withBorder: PropTypes.bool,
  /** дата атрибут для тестирования */
  "data-qa": PropTypes.string
};
export default Counter;